import { Backdrop, CircularProgress } from '@mui/material';
import React from 'react'
import PropTypes from "prop-types";

const Loading = ({isLoading=true}) => {
  return (
    <Backdrop
    sx={{
      color: "#fff",
      zIndex: (theme) => theme.zIndex.drawer + 1, // Ensures it's above other elements
      backgroundColor: "rgba(0, 0, 0, 0.5)", // Slightly opaque black
    }}
    open={isLoading} // Always open when in this loading state
  >
    <CircularProgress color="inherit" />
  </Backdrop>
  )
}

Loading.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};



export default Loading